function EMAEnrolleePeriodicCheckin() {
    "use strict";

    this.__type = 'EMACheckInSchedule:www.veritracks.com';
    this.Id = "";
    this.CheckinTypeID = 2;
    this.OffsetValue = 0;
    this.CheckinInterval = 15;
    this.NumberOfCheckIn = 1;
    this.StartTime = "";
    this.EndTime = "";
    this.IsSunday = 0;
    this.IsMonday = 0;
    this.IsTuesday = 0;
    this.IsWednesday = 0;
    this.IsThursday = 0;
    this.IsFriday = 0;
    this.IsSaturday = 0;
    this.AppUserId = "";
}
if (typeof exports !== 'undefined') {
    module.exports = EMAEnrolleePeriodicCheckin;
}